import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface EditMenuProps {
  items: MenuItem[];
}

const EditMenu: React.FC<EditMenuProps> = ({ items }) => {
  return <Menu items={items} />;
};

export default EditMenu; 